import type { ReactNode } from "react";
import { WorkspaceId } from "../workspaces.js";
import { AgentsNavigationMenu } from "./agentsNavigationMenu.js";
import { PerformanceNavigationMenu } from "./performanceNavigationMenu.js";
import { RecruitingNavigationMenu } from "./recruitingNavigationMenu.js";
import { TrainingNavigationMenu } from "./trainingNavigationMenu.js";

// Maps a workspace to its navigation menu. The `/` route uses this to render the
// menu for the feature-flag-driven default workspace at render time.
export function renderWorkspaceNavigationMenu(
  workspaceId: WorkspaceId,
): ReactNode {
  switch (workspaceId) {
    case WorkspaceId.Recruiting:
      return <RecruitingNavigationMenu />;
    case WorkspaceId.Performance:
      return <PerformanceNavigationMenu />;
    case WorkspaceId.Agents:
      return <AgentsNavigationMenu />;
    case WorkspaceId.Training:
      return <TrainingNavigationMenu />;
  }
}
